export const PERMS = {
    READ: 'countries.read',
    UPDATE: 'countries.update',
    DELETE: 'countries.delete',
    CREATE: 'countries.create',
    EXPORT: 'countries.export',
}
